import axios from 'axios'

// Poll a background ingestion job until it completes.
export async function pollJob(jobId, { interval = 1200, timeout = 90000 } = {}) {
  const start = Date.now()
  while (Date.now() - start < timeout) {
    const { data } = await axios.get(`/api/v1/jobs/${jobId}`)
    if (data.state === 'completed') return data.returnvalue || {}
    if (data.state === 'failed') throw new Error(data.failedReason || 'job failed')
    await new Promise(r => setTimeout(r, interval))
  }
  throw new Error('job timed out')
}
